import React, { useCallback, useEffect, useState } from "react";
import { validateMobileNo } from "../services/Function";
import { ToastContainer, toast } from 'react-toastify';
import { adminSendVendorOTP, adminVerifyVendorOTP, getUsers } from "../services/Api";
import { Empty, Flex, Pagination, Spin } from "antd";
import { useNavigate } from "react-router-dom";

const RegisterVendor = () => {
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [mobile, setMobile] = useState()
    const [mobileOTP, setMobileOTP] = useState()
    const [enterOTP, setEnterOTP] = useState(false)
    const [users, setUsers] = useState([]);
    const [filterType, setFilterType] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [searchValue, setSearchValue] = useState('')
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false)
    const handleSendOTP = () => {
        console.log(mobile)
        if (!validateMobileNo(mobile)) {
            toast("Invalid Mobile Number")
            return;
        }

        adminSendVendorOTP(mobile)
            .then((res) => {
                toast(res?.data?.message)
                setEnterOTP(res?.data?.success)
                console.log(res)
            })
            .catch((err) => {
                console.log(err)
                toast(err?.response?.data?.error)
            })
    }


    const handleVerifyOTP = () => {
        console.log(mobile)
        if (!mobile && !mobileOTP) {
            console.log(mobile, mobileOTP)
            toast("Invalid Mobile Number or OTP")
            return;
        }
        adminVerifyVendorOTP(mobile, mobileOTP)
            .then((res) => {
                toast(res?.data?.message)
                const user = res?.data?.data;
                console.log(res.data.data)
                setTimeout(() => {
                    navigate('/admin/vendorform', { state: { user } })
                }, 2000)
            })
            .catch((err) => {
                toast(err?.response?.data?.message)
            })
    }

    const getAllUser = useCallback(() => {
        setIsLoading(true);
        getUsers(null, null, null, filterType, searchValue, pageSize, currentPage, true)
            .then((res) => {
                setUsers(res?.data?.data);
                setTotal(res.data.total);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    }, [filterType, searchValue, pageSize, currentPage]);

    useEffect(() => {
        getAllUser();
    }, [token, searchValue, filterType, pageSize, currentPage, getAllUser]);

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    return (
        <>
            < ToastContainer />
            <div className=" space-y-6 px-5 py-5">
                <div className=" bg-[#FFF0F2] py-10 rounded-md shadow-md">
                    <div className=" text-center">
                        <p className="text-base md:text-xl lg:text-2xl text-[#3A4352] font-semibold"> Register Vendor</p>
                        <p className="text-base text-[#3A4352] font-medium"> Please fill all the Details step by step to register a vendor</p>
                    </div>
                    {!enterOTP &&
                        <div className="">
                            <div className="w-full">
                                <p className="text-center text-[#3A4352] font-semibold">Enter Mobile Number</p>
                                <div className=" w-full flex justify-center gap-5 mt-5">
                                    <input
                                        className="w-[30%] h-10 border-2 border-gray-400 outline-none rounded-md ps-2"
                                        value={mobile}
                                        type="text"
                                        maxLength={10}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            setMobile(value);
                                        }}
                                    />
                                    <button onClick={handleSendOTP} className="w-40  bg-[#E53935] hover:bg-white border-2 border-[#E53935] hover:text-[#E53935] active:scale-95 duration-500 text-white px-5 h-10 font-semibold rounded-md">Send OTP</button>
                                </div>
                            </div>
                        </div>
                    }
                    {enterOTP &&
                        <div className="">
                            <div className="w-[400px] mx-auto ">
                                <p className="text-center text-[#3A4352] font-semibold">Enter OTP</p>
                                <input
                                    className="w-full mt-3 h-10 border-2 border-gray-400 outline-none rounded-md ps-2"
                                    value={mobileOTP}
                                    type="text"
                                    maxLength={6}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        setMobileOTP(value);
                                    }}
                                />
                                <div className="flex justify-end mt-5"><button onClick={handleVerifyOTP} className=" bg-[#E53935] hover:bg-white border-2 border-[#E53935] hover:text-[#E53935] active:scale-95 duration-500 text-white px-5 py-2 font-semibold rounded-md">Verify OTP</button></div>
                            </div>
                        </div>
                    }
                </div>
                <div className="">
                    <div className="relative flex justify-end items-center gap-3 w-full mt-5 mb-2 sm:mt-0">
                        <select
                            className="w-60 h-10 px-2 text-black bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none cursor-pointer"
                            value={filterType}
                            onChange={(e) => { setFilterType(e.target.value); setSearchValue('') }}
                        >
                            <option value="" disabled>Filter By</option>
                            <option value="phoneNumber">Phone Number</option>
                            <option value="aadhaar_number">Aadhaar Number</option>
                            {/* <option value="companyName">Company Name</option> */}
                            <option value="firstName">Name</option>
                            <option value="email">Email</option>
                            {/* <option value="city">City</option> */}
                            {/* <option value="address">Address</option> */}
                            {/* <option value="status">Status</option> */}
                            {/* <option value="registeredOn">Registered On</option> */}
                            <option value="isRegistered">Verified User</option>
                            <option value="unique_id">Unique ID</option>
                        </select>
                        {filterType !== "isRegistered" && filterType !== "" && (
                            // <input
                            //     className="px-3 h-10 rounded-md bg-white border border-gray-300 outline-none"
                            //     placeholder="Search"
                            //     type={filterType === "registeredOn" ? "date" : "text"}
                            //     onChange={(e) => { setSearchValue(e.target.value); setCurrentPage(1) }}
                            // />
                            <input
                                className="px-3 h-10 rounded-md bg-white border border-gray-300 outline-none"
                                placeholder={filterType === "aadhaar_number" ? "XXXX XXXX XXXX" : "Search"}
                                type={filterType === "registeredOn" ? "date" : "text"}
                                value={searchValue}
                                maxLength={filterType === "aadhaar_number" ? 14 : undefined}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (filterType === "aadhaar_number") {
                                        value = value.replace(/\D/g, "");
                                        value = value.slice(0, 12);
                                        value = value.replace(/(\d{4})(?=\d)/g, "$1 ");
                                    }
                                    setSearchValue(value);
                                    setCurrentPage(1);
                                }}
                            />
                        )}
                    </div>
                    {isLoading ?
                        <div className='mt-20 flex justify-center items-center'>
                            <Flex gap="middle" vertical>
                                <Spin tip="Loading" size="large">
                                    <div className='p-12 rounded-xl'></div>
                                </Spin>
                            </Flex>
                        </div>
                        : (
                            users.length > 0 ? (
                                <>
                                    <div className="border rounded-lg overflow-x-auto ">
                                        <table className="w-full">
                                            <thead>
                                                <tr className=" bg-muted/50 bg-[#FFF0F2] ">
                                                    <th className="min-w-[110px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Name</th>
                                                    <th className=" min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Mobile</th>
                                                    <th className=" min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Status</th>
                                                    <th className=" min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Register</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.map((user, index) => (
                                                    <tr key={index} className="border-b last:border-0">
                                                        <td className="min-w-[110px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer">{user?.firstName || "--"}</td>
                                                        <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer">{user?.phoneNumber || "--"}</td>
                                                        <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer">{user?.isRegistered ? "Registered" : "Not Registered"}</td>
                                                        <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer">
                                                            {user?.isRegistered ? <p className="text-green-500 font-medium"> Registered</p> :
                                                                <button onClick={() => navigate('/admin/vendorform', { state: { user } })} className="bg-[#E53935] hover:bg-white border-2 border-[#E53935] hover:text-[#E53935] active:scale-95 duration-500 text-white px-5 py-2 font-semibold rounded-md" > Register </button>
                                                            }
                                                        </td>
                                                        {/* onClick={handleRegisterVendor} */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        align="end"
                                        className="mt-3"
                                        current={currentPage}
                                        total={total}
                                        pageSize={pageSize}
                                        defaultCurrent={1}
                                        showSizeChanger
                                        pageSizeOptions={['10', '20', '50', '100']}
                                        onChange={handlePageChange}
                                        onShowSizeChange={(page, size) => {
                                            setPageSize(size);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </>) : (<Empty />)
                        )}
                </div>

            </div>
        </>
    )
}
export default RegisterVendor;